"use strict";

class ProgramFormCtrl {

    constructor($state, $stateParams, Program, $http, $mdDialog, $mdToast, $rootScope, $scope, widgets) {

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this._Program = Program;
        this.$http = $http;
        this.$mdDialog = $mdDialog;
        this.buttonDisabled = false;
        this.$mdToast = $mdToast;
        this.widgets = widgets;
        this.genreModel = {};
        this.ptyList = [];
        this.groups = [];

        this.customFieldsRaw = [];
        this.customFields = {};

        this.formdata = {
            group_id: null,
            presenters: [],
            genre: {id: 0},
            tags: [],
            pty_code_id: undefined,
            pty_type: "rds",
            disabled: 0
        };

        this.checkForRelatedPrograms = {};

        this.getProgramUrl = function() {
            if(this.formdata.title){
                let programId;
                if ($stateParams.programId) {
                    programId = $stateParams.programId;
                } else {
                    programId = 0;this.formdata.title
                }
                let program = encodeURIComponent(this.formdata.title.replace('/', ''));
                let url = 'programs/unique_program/' + program + '/' + programId;
                return url;
            }
        }.bind(this);

        //Get the list of the stations
        //this.fetchGroups();

        this.checkRelatedPrograms = () => {
            this.checkForRelatedPrograms.update();
        };

        //get the station settings
        this.$http.get('/station/').then(result => {
            this.formdata.pty_code_id = (result.data.pty_code);
            this.formdata.pty_type = result.data.pty_type;
        });

        this.treeOptions = {
            nodeChildren: 'children',
            dirSelectable: true,
            allowDeselect: false
        };

        //get the EBU genre list
        this.$http.get('/genres/tree').then(result => {
            this.treedata = result.data;
        });

        this.$scope.$on('made_new_presenter', this.addCreatedPresenter.bind(this));

        if ($stateParams.programId) {
            this.getModelTypes().then(() => {
                Program.get({id: $stateParams.programId}, (data) => {
                    if (data.genre === null) {
                        data.genre = {id: 0};

                        $http.get('/station/genre').then((result) => {
                            if (result.data) {
                                this.genreModel = result.data;
                            }
                        });
                    } else {
                        this.genreModel = data.genre;
                    }

                    angular.extend(this.formdata, data);
                    this.formdata.model_type_id = data.model_type_id;
                    this.formdata.disabled = data.disabled ? 1 : 0;
                });

                this.$http.get('/ptycodes/').then((response) => {
                    this.ptyList = response.data.details;
                    this.formdata.pty_type = response.data.type;
                });

            });
        } else {
            this.getModelTypes().then(() => {
                this.formdata.model_type_id = this.customFieldsRaw[0].id;
            });

            $http.get('/station/genre').then((result) => {
                if (result.data) {
                    this.genreModel = result.data;
                }
            });

            this.$http.get('/ptycodes/').then((response) => {
                this.ptyList = response.data.details;
                this.formdata.pty_type = response.data.type;
                this.formdata.disabled = response.data.disabled ? 1 : 0;
            });

            this.$http.get('/station/autofill').then((response) => {
                this.formdata.pty_code_id = response.data.pty_code;
                this.formdata.language = response.data.language;
                this.formdata.tags = response.data.tags;
            });
        }

        this.tabSelected = 1;
        setTimeout(() => {
            this.tabSelected = 0;
        });

        if( $stateParams.title ){
            this.formdata.title = $stateParams.title;
        }

    }

    fetchGroups () {
        this.$http.get('/groups/all')
            .then(response => {
                this.groups = response.data
            })
    }

    getModelTypes() {
        return this.$http.get('/modeltypes/program', {cache: true}).then((response) => {
            this.customFieldsRaw = response.data.program;
            response.data.program.forEach((data) => {
                this.customFields[data.id] = data.fields;
            });
            return response.data;
        });
    }

    tagSearch(query) {

        return this.$http.get('/tags/search/' + encodeURIComponent(query)).then(result => {

            return result.data;
        });
    }

    //this date transform the custom date to 'new Date' so it can be re-used
    makeDate(date) {
        return date ? new Date(date) : new Date();
    }

    presenterSearch(query) {

        return this.$http.get('/presenters/search/' + encodeURIComponent(query)).then(result => {

            return result.data;
        });
    }

    selectedItemChange(item) {
    }

    searchTextChange(text) {
    }

    cancel() {

        this.$state.go('programs');
    }

    save($valid) {

        if (!$valid) {
            return;
        }

        this.buttonDisabled = true;

        this.widgets.saveWidgetsForTypeId('program-' + this.formdata.id).then(() => {
            let modelData = angular.copy(this.formdata);
            modelData.pty_code_id = Number(modelData.pty_code_id);
            modelData.genre_id = this.genreModel.id;
            modelData.disabled = Number(modelData.disabled);

            modelData.presenter_ids = modelData.presenters.map(presenter => {
                return presenter.id;
            });

            delete modelData.presenters;

            delete modelData.genreQuery;
            delete modelData.genre;

            this._Program.save(modelData, (data) => {

                let type = this.formdata.id ? 'saved' : 'create';
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.' + type + '?object=program&title=' + this.formdata.title, //@trans('labels.program')
                    hideDelay: 3000,
                    position: ('top right')
                });
                if (data.disabled) {
                    if (this.$stateParams.fromOtherSource) {
                        this._Program.get({id: data.id}, (withModelType) => {
                            this.$rootScope.$broadcast('broadcast_new_program', withModelType);
                        });
                    }
                    this.$state.go('programs').then(() => {
                        this.$state.reload();
                    });
                } else {
                    if (this.$stateParams.fromOtherSource) {
                        this._Program.get({id: data.id}, (withModelType) => {
                            this.$rootScope.$broadcast('broadcast_new_program', withModelType);
                        });
                        this.backBroadcast();
                    } else {
                        this.$state.go('programs.update', {programId: data.id}, {'reload': true});
                    }
                }
            }, (data) => {
                console.log(data.data.error)
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.error_message?plain_error=' + data.data.error, //@trans('labels.program')
                    hideDelay: 3000,
                    position: ('top right')
                });
                this.buttonDisabled = false;
            });
        })
    }

    //Modalbox
    showRevisions(ev) {

        this.$http.get('/revisions/programs/' + this.$stateParams.programId).then(revisions => {

            this.$mdDialog.show({

                controller: 'RevisionDialogCtrl',
                templateUrl: 'revisionDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {

                    revisions: revisions.data
                }
            }).then((values) => {
                this.formdata.title = values.title;
                this.formdata.model_type_id = values.model_type_id;
                this.formdata.description = values.description;
                this.formdata.short_name = values.short_name;
                this.formdata.medium_name = values.medium_name;
                this.formdata.website = values.website;
                this.formdata.email = values.email;
                this.formdata.language = values.language;
                this.formdata.recommended = values.recommended;
                this.formdata.field_values = JSON.parse(values.field_values);

                this.updateGenre(values.genre_id, this.treedata);

                this.formdata.tags = values.tags;

                if (values.presenters.length > 0) {
                    this.$http.get('presenters/ids/' + values.presenters).then((res) => {
                        this.formdata.presenters = res.data;
                    });
                } else {
                    this.formdata.presenters = [];
                }
            }).catch(() => {});;
        });
    }

    updateGenre(id, genres) {
        genres.forEach((genre) => {
            if (genre.id == id) {
                this.genreModel = genre;
                return;
            }

            if (genre.children) {
                this.updateGenre(id, genre.children);
            }
        });
    }

    genre(ev) {

        this.$mdDialog.show({

            controller: 'TreeControllerDialogCtrl',
            templateUrl: "genreDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true,

            locals: {

                genreModel: this.genreModel
            }

        }).then(($node) => {

            this.genreModel = $node;
            this.formdata.genre_id = $node.id;
        });
    };

    isUpdate() {
        return this.formdata.id ? true : false;
    }

    //cancel button when creating program in epg
    backBroadcast() {
        this.$state.go('^');
    }

    addPresenter() {
        this.$state.go('.presenter');
    }

    addCreatedPresenter(e, presenter) {
        this.formdata.presenters.push(presenter);
    }
}

ProgramFormCtrl.$inject = ['$state', '$stateParams', 'Program', '$http', '$mdDialog', '$mdToast', '$rootScope', '$scope', 'widgets'];

module.exports = ProgramFormCtrl;
